import apiurl from './apiurl';
const axios = require('axios');

const obj = {
    // Función para obtener nombres de empresas
    reprocesarfolios: async (params,idToken) => {
        return axios({
            method: 'POST',
            url: apiurl + 'reprocesarFolios',
            headers: {
                'content-type': 'application/json',
                'Authorization': "Bearer " + idToken
            },
            data: params,
            crossdomain: true,
        });
    },
};

export default obj;